import { render, staticRenderFns } from "./GPProcessEvent.vue?vue&type=template&id=313a13dd&"
import script from "./GPProcessEvent.vue?vue&type=script&lang=js&"
export * from "./GPProcessEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports